import PARENT from '../types';

const SCENES = `${PARENT}/SCENES`;

export default SCENES;
